/* KW 3.0 — three fixes for Seal's widget on the refill's own page.

   ── 1. Keep the kit's plan out of the widget ─────────────────
   The Wash Refill carries two Seal selling-plan groups:

     Subscribe & Save   the refill on its own — 20 / 15 / 10% off
     Kit add-on         the plan the CWS page attaches to a kit purchase:
                        100% off the first cycle, because the first set of
                        liquids is already in the box

   Seal's widget lists every group on the product, so the refill page showed
   "KIT ADD-ON · SAVE 100% · £0.00" as a purchase option — pre-selected, with
   the button reading "Add to basket — £0.00". Meaningless on its own and an
   open invitation to a chancer. The plan has to stay on the product (the kit
   page needs it), so it is removed from the widget here instead. Matched on
   the plan ids first, the group name as a fallback.

   ── 2. Start from a state that means something ───────────────
   With the kit option gone, Seal mounted with the subscription radio checked,
   no option highlighted, and the selling_plan field empty — so the page said
   £36 and the basket would have taken £45. If nothing is visibly chosen once
   the widget has settled, the first option (one-time purchase) is chosen for
   it, through Seal's own click handling, so every part of Seal agrees.

   ── 3. Paint the price from the selection ────────────────────
   Seal rewrites the page price and the button when a subscription is chosen
   — £45 becomes £36 — and then does not put them back when the customer
   returns to one-time purchase. The hidden selling_plan field is cleared
   correctly, so checkout charges £45; only the page still says £36, which is
   the wrong number in the wrong direction for a page meant to be
   unmisreadable.

   So the theme no longer trusts Seal's repaint. On every change of selection
   it reads the price Seal itself prints inside the chosen option and writes
   that into the price line and the button, and swaps the delivery note to
   the subscription's promise (free delivery, pause or cancel) and back. One
   source, both directions.

   The widget renders after Seal's own script runs, so an observer watches
   for it and for its selection class flipping. */

(function () {
  var PLAN_IDS = ['692452393289', '692452426057', '692452458825'];
  var GROUP = /kit add-on/i;
  var MDASH = String.fromCharCode(8212);

  function isKit(opt) {
    var radio = opt.querySelector('input[type="radio"], input[type="checkbox"]');
    if (radio && PLAN_IDS.indexOf(String(radio.value)) !== -1) return true;
    var sel = opt.querySelector('select');
    if (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (PLAN_IDS.indexOf(String(sel.options[i].value)) !== -1) return true;
      }
    }
    return GROUP.test(opt.textContent || '');
  }

  function firstVisible(root) {
    return root.querySelector('.sls-option-container:not([hidden]) input[type="radio"]');
  }

  function guard(root) {
    var opts = root.querySelectorAll('.sls-option-container');
    if (!opts.length) return false;
    var removedActive = false;
    opts.forEach(function (opt) {
      if (opt.dataset.kwGuarded === '1') return;
      if (!isKit(opt)) return;
      opt.dataset.kwGuarded = '1';
      if (opt.classList.contains('sls-active')) removedActive = true;
      opt.hidden = true;
      opt.setAttribute('aria-hidden', 'true');
    });
    if (removedActive) {
      var first = firstVisible(root);
      if (first) first.click();
    }
    return true;
  }

  /* Once, after Seal has settled: if nothing is highlighted, choose one-time. */
  function settle(root) {
    if (root.dataset.kwSettled === '1') return;
    if (!root.querySelector('.sls-option-container')) return;
    root.dataset.kwSettled = '1';
    setTimeout(function () {
      if (root.querySelector('.sls-option-container.sls-active:not([hidden])')) { syncPrice(root); return; }
      var first = firstVisible(root);
      if (first) first.click();
      setTimeout(function () { syncPrice(root); }, 80);
    }, 250);
  }

  /* The price Seal prints inside an option: the live figure, not a struck
     compare-at beside it. */
  function optionPrice(opt) {
    var nodes = opt.querySelectorAll('.sls-total-price .seal-money, .sls-price .seal-money, .seal-money');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.closest('s, del, .sls-compare-at-price')) continue;
      var t = (n.textContent || '').trim();
      if (t) return t;
    }
    return '';
  }

  function activeOption(root) {
    var a = root.querySelector('.sls-option-container.sls-active:not([hidden])');
    if (a) return a;
    var r = root.querySelector('.sls-option-container:not([hidden]) input[type="radio"]:checked');
    return r ? r.closest('.sls-option-container') : null;
  }

  function isSubscription(opt) {
    var r = opt.querySelector('input[type="radio"]');
    return !!r && r.getAttribute('data-type') !== 'one_time' && r.value !== 'one_time';
  }

  function syncPrice(root) {
    var opt = activeOption(root);
    if (!opt) return;
    var price = optionPrice(opt);
    if (!price) return;

    var section = root.closest('[data-kw-plans]') || document;
    var priceEl = section.querySelector('[data-kw-price]');
    if (priceEl) priceEl.textContent = price;

    var paint = function (btn) {
      var span = btn.querySelector('span');
      if (!span) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      span.textContent = (btn.dataset.kwCta || 'Add to basket') + ' ' + MDASH + ' ' + price;
    };
    var cta = section.querySelector('[data-kw-cta]');
    if (cta) paint(cta);
    document.querySelectorAll('[data-kw-cta-proxy]').forEach(paint);

    /* The delivery promise under the button follows the selection. The plain
       version is captured the first time through, so switching back has
       something to restore. */
    var ship = section.querySelector('[data-kw-ship]');
    if (ship) {
      if (!ship.dataset.kwShipBase) ship.dataset.kwShipBase = ship.innerHTML;
      var sub = ship.getAttribute('data-kw-ship-sub');
      if (isSubscription(opt) && sub) ship.textContent = sub;
      else ship.innerHTML = ship.dataset.kwShipBase;
    }
  }

  function init() {
    var roots = document.querySelectorAll('.sealsubs-target-element');
    if (!roots.length) return;
    roots.forEach(function (root) {
      guard(root);
      settle(root);
      if (root.dataset.kwGuardObs === '1') return;
      root.dataset.kwGuardObs = '1';

      /* Let Seal finish its own repaint, then overwrite it with the truth. */
      var later = function () { setTimeout(function () { syncPrice(root); }, 60); };
      root.addEventListener('click', later, true);
      root.addEventListener('change', later, true);

      if ('MutationObserver' in window) {
        new MutationObserver(function () { guard(root); settle(root); later(); })
          .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Seal mounts its widget late; a body observer catches the mount itself. */
  if ('MutationObserver' in window) {
    new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', init);
})();